export var birRequestStatuses = {
  DRAFT: 'draft',
  OPEN: 'open',
  SALES: 'sales',
  REVIEW: 'review',
  PENDING: 'pending',
  COMPLETED: 'completed'
};
export var birRequestSteps = {
  GENERAL: 'general',
  GENERAL_INFO: 'general_information',
  CONTROL: 'company_control',
  OPERATIONS: 'operations',
  DOCUMENTS: 'documents_requested',
  CORPORATE: 'corporate_linkage',
  FACILITIES: 'type_of_facilities',
  FINANCIAL: 'financial_information_last_fiscal_year',
  FINISHED: 'finished'
};